<template>
  <li class="headline">{{ t('menu.tabs.playersMenu') }}</li>
  <li @click="playersMenu.changePronouns = !playersMenu.changePronouns">
    <small>
      <div>
        <font-awesome-icon icon="venus-mars" class="fa fa-venus-mars" />
        {{ t('player.changePronouns') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.changePronouns ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.changeName = !playersMenu.changeName">
    <small>
      <div>
        <font-awesome-icon icon="user-edit" class="fa fa-user-edit" />
        {{ t('player.changeName') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.changeName ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.movePlayer = !playersMenu.movePlayer">
    <small>
      <div>
        <font-awesome-icon icon="redo-alt" class="fa fa-redo-alt" />
        {{ t('player.movePlayer') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.movePlayer ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.swapPlayers = !playersMenu.swapPlayers">
    <small>
      <div>
        <font-awesome-icon icon="exchange-alt" class="fa fa-exchange-alt" />
        {{ t('player.swapPlayers') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.swapPlayers ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.removePlayer = !playersMenu.removePlayer">
    <small>
      <div>
        <font-awesome-icon icon="times-circle" class="fa fa-times-circle" />
        {{ t('player.removePlayer') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.removePlayer ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.emptySeat = !playersMenu.emptySeat">
    <small>
      <div>
        <font-awesome-icon icon="chair" class="fa fa-chair" />
        {{ t('player.emptySeat') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.emptySeat ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.swapAlignment = !playersMenu.swapAlignment">
    <small>
      <div>
        <font-awesome-icon icon="yin-yang" class="fa fa-yin-yang" />
        {{ t('player.swapAlignment') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.swapAlignment ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.specialVote = !playersMenu.specialVote">
    <small>
      <div>
        <font-awesome-icon icon="vote-yea" class="fa fa-vote-yea" />
        {{ t('player.specialVote') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.specialVote ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.rochambo = !playersMenu.rochambo">
    <small>
      <div>
        <font-awesome-icon icon="hand-scissors" class="fa fa-hand-scissors" />
        {{ t('player.rochambo') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.rochambo ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="playersMenu.signal = !playersMenu.signal">
    <small>
      <div>
        <font-awesome-icon icon="tower-broadcast" class="fa fa-tower-broadcast" />
        {{ t('player.signal') }}
      </div>
    </small>
    <em>
      <font-awesome-icon :icon="[
        'fas',
        playersMenu.signal ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
</template>

<script setup lang="ts">
import {
  useLocaleStore,
  usePlayersMenuStore,
} from "@/stores";

const locale = useLocaleStore();
const t = locale.t;
const playersMenu = usePlayersMenuStore();
</script>

<style lang="scss" src="./Menu.scss" scoped></style>
